import { Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'ridango-dropdown-default-item',
    templateUrl: './dropdown-default-item.component.html',
    styleUrls: ['./dropdown-default-item.component.css']
})
export class DropdownDefaultItemComponent implements OnInit {
    @Input() item;
    @Input() isSelected = false;
    @Input() id: string;

    @ViewChild('listItem', { static: true }) listItem: ElementRef;


    @HostBinding('attr.role') role = 'none';

    ngOnInit() {}

    focus(): void {
        setTimeout(() => this.listItem.nativeElement.focus());
    }
}
